module.exports = __webpack_public_path__ + "static/media/shoppingCart.736d3059.webp";